<template>
  <van-overlay :show="visible" @click="handleOverlayClick" :z-index="999999">
    <div class="qr-popup-container" @click.stop>
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <van-icon name="cross" color="#ffffff" size="13px" />
      </div>

      <!-- 海报卡片 -->
      <div class="poster-card">
        <!-- 加载状态 -->
        <div v-if="isGeneratingPoster" class="loading-state">
          <div class="loading-spinner"></div>
          <div class="loading-text">正在生成邀请海报...</div>
        </div>

        <!-- 海报图片 -->
        <img
          v-else-if="posterImageSrc"
          :src="posterImageSrc"
          alt="邀请海报"
          class="poster-image"
          @load="handlePosterLoad"
        />

        <!-- 生成失败状态 -->
        <div v-else class="error-state">
          <div class="error-text">海报生成失败</div>
          <button @click="retryGeneratePoster" class="retry-btn">
            重新生成
          </button>
        </div>
      </div>
      <div class="poster-card-tips" v-if="posterImageSrc">
        长按二维码保存图片，把二维码分享给好友，对方扫描即可一键开启金声玉亮的精彩体验
      </div>
    </div>
  </van-overlay>
</template>

<script>
import Vue from "vue";
import { Overlay, Icon, Toast } from "vant";
import { QRCodeGenerator } from "@/utils/qrCodeGenerator";

Vue.use(Overlay);
Vue.use(Icon);

export default {
  name: "QRCodePopup",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "https://fingpt.ainvestcn.com",
    },
  },
  data() {
    return {
      posterImageSrc: null,
      qrGenerator: null,
      isGeneratingPoster: false,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.generatePoster();
      } else {
        this.posterImageSrc = null;
        this.isGeneratingPoster = false;
      }
    },
  },
  methods: {
    handleOverlayClick() {
      // 点击遮罩层关闭弹窗
      this.handleClose();
    },
    handleClose() {
      this.$emit("close");
    },
    async generatePoster() {
      try {
        this.isGeneratingPoster = true;
        this.posterImageSrc = null;

        this.qrGenerator = new QRCodeGenerator();

        // 生成完整的邀请海报
        const posterBase64 = await this.qrGenerator.generateInvitePoster(
          this.url
        );

        this.posterImageSrc = posterBase64;
        this.isGeneratingPoster = false;
      } catch (error) {
        console.error("生成海报失败:", error);
        Toast.fail("生成海报失败");
        this.isGeneratingPoster = false;
      }
    },
    async retryGeneratePoster() {
      await this.generatePoster();
    },
    handlePosterLoad() {
      // 海报加载完成
      console.log("海报加载完成");
    },
  },
  beforeDestroy() {
    if (this.qrGenerator) {
      this.qrGenerator.destroy();
    }
  },
};
</script>

<style lang="less" scoped>
.qr-popup-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  z-index: 999999;
}

.close-btn {
  position: absolute;
  top: 40px;
  right: 40px;
  width: 37px;
  height: 37px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000000;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &:active {
    transform: scale(0.95);
  }
}

.poster-card {
  width: 334px;
  height: 467px;
  background: transparent;
  border-radius: 32px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.poster-card-tips {
    font-family: PingFangSC-Bold;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    word-break: break-all;
    color: #FFFFFFCC;
    margin: 24px 30px 0;
  }

.poster-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #333333;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top: 3px solid #000000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-family: "PingFangSC-Regular", PingFang SC;
  font-size: 16px;
  color: #333333;
  text-align: center;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #333333;
  text-align: center;
}

.error-text {
  font-family: "PingFangSC-Regular", PingFang SC;
  font-size: 16px;
  color: #333333;
}

.retry-btn {
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-family: "PingFangSC-Regular", PingFang SC;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #333333;
  }

  &:active {
    transform: scale(0.95);
  }
}

/* 响应式适配 */
@media (max-width: 430px) {
  .qr-popup-container {
    padding: 15px;
  }

  .close-btn {
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
  }

  .poster-card {
    margin-top: 80px;
    width: calc(100vw - 50px);
    max-width: 334px;
    height: auto;
    aspect-ratio: 334 / 467;
  }

  .poster-card-tips {
    margin: 60px 30px 0;
  }
}

@media (max-width: 375px) {
  .qr-popup-container {
    padding: 10px;
  }

  .close-btn {
    top: 15px;
    right: 15px;
  }

  .poster-card {
    margin-top: 60px;
    width: calc(100vw - 60px);
  }

  .poster-card-tips {
    margin: 36px 30px 0;
  }
}

</style>
